<script>
import ButtonElement from "%/dynamic-component-editor/standard-elements/button-element/ButtonElement.vue";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import ButtonOptions from "%/dynamic-component-editor/bundles/button-options";
import StartCallText from "%/dynamic-component-editor/options/start-call-text";
import JoinCallText from "%/dynamic-component-editor/options/join-call-text";
import LeaveCallText from "%/dynamic-component-editor/options/leave-call-text";
import { ConversationCallElementMixin }
  from "%/dynamic-component-editor/standard-elements/conversation-call/conversation-call-element-mixin";

const LABEL_OPTION_BY_STATE = {
  start: StartCallText,
  join: JoinCallText,
  leave: LeaveCallText,
};

export default {
  name: "ConversationJoinCallButton",
  elementPanelSettings: {
    displayName: "Join Call",
    displayIcon: "button",
    elementType: "element",
    elementGroup: "general",
  },
  // A standard button (all its styling options) whose click opens this page's
  // Video Call for the bound conversation, instead of a free Click Action.
  extends: ButtonElement,
  mixins: [DynamicElementWithContext, ConversationCallElementMixin],
  // The standard button bundle, minus the rows the call owns: the label comes
  // from Start/Join/Leave Text, and the click is the join, not a link.
  optionBundles: [
    new ButtonOptions({}, {
      "text-option": true,
      "link-type": true,
      "href-option": true,
    }),
  ],
  options: [StartCallText, JoinCallText, LeaveCallText],
  hidden: true,
  computed: {
    shouldRenderButton() {
      return true;
    },
    callButtonState() {
      if (this.isCallPlaceholder) {
        return "join";
      }
      if (this.callTarget && this.callStore.isInCall(this.callTarget)) {
        return "leave";
      }

      return this.callPresence.active ? "join" : "start";
    },
    // The standard button reads its label from this option class, so the
    // label follows the call state and each state's label is its own option.
    textValueOptionClass() {
      return LABEL_OPTION_BY_STATE[this.callButtonState];
    },
    textOptionValue() {
      return this.getOptionValue(this.textValueOptionClass) || "";
    },
  },
  methods: {
    handleButtonClick() {
      if (this.isCallPlaceholder) {
        return;
      }
      if (!this.callTarget) {
        // eslint-disable-next-line no-console
        console.error("Join Call could not work out which call to join — nothing was opened", {
          identifier: this.identifier,
          boundContext: this.elementContext?.entityContext,
          conversationPk: this.contextItem?.entityPkUrlVars ?? null,
          renderDestinationId: window.blclient?.data?.renderDestinationId ?? null,
          chatConfigurationId: window.blclient?.data?.dbApps?.Chat?.configurationId ?? null,
        });

        return;
      }
      if (this.callButtonState === "leave") {
        this.callStore.closeCall(this.callTarget);

        return;
      }
      this.callStore.requestJoin(this.callTarget);
    },
  },
};
</script>
